import "./index.scss";

const CheckBox = ({
  item,
  checked,
  onChange,
  disabled,
}: {
  item: { id: string; title: string };
  checked: boolean;
  disabled?: boolean;
  onChange: (data: any) => void;
}) => {
  return (
    <div className="radio-button">
      <div className="flex items-center">
        <label
          htmlFor={item.id}
          className="mr-3 block text-sm font-medium leading-6"
        >
          {item.title}
        </label>
        <input
          id={item.id}
          name="position"
          type="checkbox"
          className="focus:ring-transparent"
          checked={checked}
          onChange={(value) => (!disabled ? onChange(value) : {})}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default CheckBox;
